<template>
  <div class="dashboard-wrapper">
    <ShopdropLogo class="logo" />
    <div class="welcome-message">
      <p class="notify">Hi! Welcome to your Shopdrop dashboard</p>
    </div>
    <div class="dashboard-data">
      <div class="card-wrapper">
        <v-card elevation="2" outlined>
          <v-card-text>
            <a @click="$emit('changeView', 1)">More info</a></v-card-text
          >
          <v-card-subtitle
            ><p class="notify">
              Total <span class="emphasize-1">users </span>count<br /></p
          ></v-card-subtitle>
          <v-card-title>{{ userCount }}</v-card-title>
        </v-card>
      </div>
      <div class="card-wrapper">
        <v-card elevation="2" outlined>
          <v-card-text>
            <a @click="$emit('changeView', 2)">More info</a></v-card-text
          >
          <v-card-subtitle
            ><p class="notify">
              Total <span class="emphasize">products </span>saved<br /></p
          ></v-card-subtitle>
          <v-card-title>{{ productCount }}</v-card-title>
        </v-card>
      </div>
    </div>
    <v-chip class="ma-2 contact-us" color="#ba22cc" outlined @click="contactUs">
      <v-icon left color="rgb(20,200,200)"> mdi-phone </v-icon>
      Contact us
    </v-chip>
  </div>
</template>

<script>
import ShopdropLogo from "../../images/ShopdropLogo2.svg";
import groupBy from "lodash.groupby";

export default {
  name: "merchantViewDashboard",
  components: {
    ShopdropLogo,
  },
  props: {
    merchantProducts: {
      type: Array,
    },
  },
  computed: {
    productCount() {
      return this.merchantProducts.length;
    },
    userCount() {
      const merchantGrouping = groupBy(this.merchantProducts, "listId");
      return Object.keys(merchantGrouping).length;
    },
  },
  methods: {
    async contactUs() {
      this.isShareWhatsAppModalOn = false;
      window.open(
        "https://web.whatsapp.com/972546601121?text=Hi!, I have a question about Shopdrop..."
      );
    },
  },
};
</script>

<style scoped>
.dashboard-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
}
.dashboard-data {
  display: flex;
  justify-content: center;
  align-items: center;
}
.emphasize {
  font: 500;
  color: rgb(20, 200, 200);
}
.emphasize-1 {
  font: 500;
  color: #ba22cc;
}
.notify {
  font-family: Helvetica Neue;
  font-size: 30px;
  font-weight: 300;
}
.logo {
  height: auto;
  width: 30%;
}
.welcome-message {
  margin-bottom: 40px;
}
.card-wrapper {
  display: flex;
  margin: 30px;
}
.contact-us {
  display: flex;
  align-self: start;
}
</style>